import { createBrowserRouter, Navigate } from "react-router-dom";
import App from "./App";
import Home from "./presenters/navigation/unlogged-area/home";
import { SignUp } from "./presenters/navigation/unlogged-area/sign-up";
import CandidateFormConfirmationRequest from "./presenters/navigation/unlogged-area/sign-up/candidate/candidate-form-confirmation-request";
import CandidateFormConfirmationSuccess from "./presenters/navigation/unlogged-area/sign-up/candidate/candidate-form-confirmation-success";
import Login from "./presenters/navigation/unlogged-area/login";
import ForgotPassword from "./presenters/navigation/unlogged-area/forgot-password";
import ForgotEmail from "./presenters/navigation/unlogged-area/forgot-email";
import ResetPassword from "./presenters/navigation/unlogged-area/reset-password";
import CandidateProfile from "./presenters/navigation/logged-area/candidate-profile";
import CompanyFormConfirmationRequest from "./presenters/navigation/unlogged-area/sign-up/company/company-form-confirmation-request";
import CompanyFormConfirmationSuccess from "./presenters/navigation/unlogged-area/sign-up/company/company-form-confirmation-success";
import VerificationExpired from "./presenters/navigation/unlogged-area/sign-up/verification-expired";

import JobOffer from "./presenters/navigation/logged-area/job-offer";
import CompanyUserProfile from "./presenters/navigation/logged-area/company-user-profile";
import JobOfferDetails from "./presenters/navigation/logged-area/job-offer-details";
import Candidates from "./presenters/navigation/logged-area/candidates";
import Candidate from "./presenters/navigation/logged-area/candidate";
import JobSubscriptions from "./presenters/navigation/logged-area/job-subscriptions";
import JobOffersPanel from "./presenters/navigation/logged-area/job-offers-panel";
import LoggedArea from "./presenters/navigation/logged-area";
import ValidateToken from "./presenters/navigation/unlogged-area/validate-token";
import { TermsOfUse } from "./presenters/navigation/unlogged-area/terms-of-use";
import { PrivacyPolicy } from "./presenters/navigation/unlogged-area/privacy-policy";
import { FAQ } from "./presenters/navigation/unlogged-area/faq";
import OffersWrapper from "./presenters/navigation/offers-wrapper";
import JobManagerProfile from "./presenters/navigation/logged-area/job-manager-profile";

export const router = createBrowserRouter([
    {
        path: '/',
        element: <App />,
        children: [
            {
                path: '/',
                element: <Home />
            },
            {
                path: '/:section',
                element: <Home />
            },
            {
                path: '/terms-of-use',
                element: <TermsOfUse />
            },
            {
                path: '/privacy-policy',
                element: <PrivacyPolicy />
            },
            {
                path: '/faq',
                element: <FAQ />
            },
            {
                path: '/offers',
                element: <OffersWrapper />
            },
            {
                path: '/sign-up',
                element: <SignUp />
            },
            {
                path: '/sign-up/:usertype',
                element: <SignUp />
            },
            {
                path: '/sign-up/candidate/confirmation/request',
                element: <CandidateFormConfirmationRequest />
            },
            {
                path: '/sign-up/candidate/confirmation/success',
                element: <CandidateFormConfirmationSuccess />
            },
            {
                path: '/sign-up/company/confirmation/request',
                element: <CompanyFormConfirmationRequest />
            },
            {
                path: '/sign-up/company/confirmation/success',
                element: <CompanyFormConfirmationSuccess />
            },
            {
                path: '/sign-up/verification/expired',
                element: <VerificationExpired />
            },
            {
                path: '/login',
                element: <Login />
            },
            {
                path: '/forgot-password',
                element: <ForgotPassword />
            },
            {
                path: '/forgot-email',
                element: <ForgotEmail />
            },
            {
                path: '/reset-password',
                element: <ResetPassword />
            },
            {
                path: '/validate-token',
                element: <ValidateToken />
            },
            {
                path: '/',
                element: <LoggedArea />,
                children: [
                    {
                        path: '/job-subscriptions',
                        element: <JobSubscriptions />
                    },
                    {
                        path: '/offers/panel',
                        element: <JobOffersPanel />
                    },
                    {
                        path: '/offers/create',
                        element: <JobOffer />
                    },
                    {
                        path: '/offers/:offer_id',
                        element: <JobOffer />
                    },
                    {
                        path: '/offers/:offer_id/candidates',
                        element: <Candidates />
                    },
                    {
                        path: '/offers/:offer_id/details',
                        element: <JobOfferDetails />
                    },
                    {
                        path: '/offers/:offer_id/candidates/:jobapply_id',
                        element: <Candidate />
                    },
                    {
                        path: '/profile/company/user',
                        element: <CompanyUserProfile />
                    },
                    {
                        path: '/profile/candidate',
                        element: <CandidateProfile />
                    },
                    {
                        path: '/profile/candidate/:section',
                        element: <CandidateProfile />
                    },
                    {
                        path: '/profile/job-manager',
                        element: <JobManagerProfile />
                    }
                ]
            },
            {
                path: '*',
                element: <Navigate to="/" replace />
            }
        ]
    }
])